<template>
  <div class="setting-page">
    <header class="setting-page__header">
      <h1 class="setting-page__title">
        {{ $store.state.language === 'en' ? 'My Account' : 'ကျွန်ုပ်၏ အကောင့်' }}
      </h1>
      <p class="setting-page__subtitle">
        {{ $store.state.language === 'en' ? 'Manage your profile & settings' : 'ပရိုဖိုင် နှင့် ဆက်တင်များ' }}
      </p>
    </header>

    <!-- Profile card -->
    <section class="setting-panel profile-card">
      <div class="setting-panel__accent"></div>
      <div class="profile-card__body">
        <div class="profile-card__hero">
          <img
            class="profile-card__avatar"
            src="https://storage.googleapis.com/spacetech2/general/profile.png"
            alt="Profile"
          />
          <div class="profile-card__identity">
            <h2 class="profile-card__name">{{ $store.state.authUser.name }}</h2>
            <p class="profile-card__username">@{{ $store.state.authUser.user_name }}</p>
          </div>
        </div>

        <div class="profile-card__balance">
          <span class="profile-card__balance-label">{{ $t('setting.balance') }}</span>
          <span class="profile-card__balance-value">
            {{ Number($store.state.amount).toLocaleString() }}
            <small>MMK</small>
          </span>
        </div>

        <div class="profile-card__grid">
          <div class="profile-card__cell">
            <span class="profile-card__cell-label">{{ $t('setting.total_withdraw') }}</span>
            <span class="profile-card__cell-value">
              {{ formatAmount($store.state.totalWithdraw) }} MMK
            </span>
          </div>
          <div class="profile-card__cell">
            <span class="profile-card__cell-label">{{ $t('setting.phone') }}</span>
            <span class="profile-card__cell-value">
              {{ blurLastFiveCharacters($store.state.authUser.phone) }}
            </span>
          </div>
        </div>
      </div>
    </section>

    <!-- Quick actions -->
    <section class="quick-actions">
      <button type="button" class="quick-action" @click="$router.push('/deposit')">
        <span class="quick-action__icon">
          <i class="fas fa-wallet" aria-hidden="true"></i>
        </span>
        <span class="quick-action__label">{{ $t('setting.deposit') }}</span>
      </button>
      <button type="button" class="quick-action" @click="$router.push('/withdraw')">
        <span class="quick-action__icon">
          <i class="fas fa-hand-holding-usd" aria-hidden="true"></i>
        </span>
        <span class="quick-action__label">{{ $t('setting.withdraw') }}</span>
      </button>
      <button type="button" class="quick-action" @click="$router.push('/history')">
        <span class="quick-action__icon">
          <i class="fas fa-history" aria-hidden="true"></i>
        </span>
        <span class="quick-action__label">{{ $t('setting.transaction') }}</span>
      </button>
    </section>

    <!-- Settings menu -->
    <section class="setting-panel menu-panel">
      <div class="setting-panel__accent"></div>
      <ul class="menu-list">
        <li class="menu-list__item menu-list__item--static">
          <span class="menu-list__icon"><i class="fas fa-user" aria-hidden="true"></i></span>
          <span class="menu-list__text">
            {{ $t('setting.name') }} — {{ $store.state.authUser.user_name }}
          </span>
        </li>

        <li
          class="menu-list__item"
          data-toggle="modal"
          data-target="#editUserPassword"
        >
          <span class="menu-list__icon"><i class="fas fa-key" aria-hidden="true"></i></span>
          <span class="menu-list__text">{{ $t('setting.update_password') }}</span>
          <i class="fas fa-chevron-right menu-list__arrow" aria-hidden="true"></i>
        </li>

        <li class="menu-list__item" @click="() => $router.push('/banking')">
          <span class="menu-list__icon"><i class="fas fa-university" aria-hidden="true"></i></span>
          <span class="menu-list__text">{{ $t('setting.bank_account') }}</span>
          <i class="fas fa-chevron-right menu-list__arrow" aria-hidden="true"></i>
        </li>

        <li class="menu-list__item menu-list__item--dropdown">
          <div
            class="menu-list__dropdown-trigger"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            id="navbar-language"
          >
            <span class="menu-list__icon"><i class="fas fa-globe" aria-hidden="true"></i></span>
            <span class="menu-list__text">{{ $t('setting.update_language') }}</span>
            <i class="fas fa-chevron-right menu-list__arrow" aria-hidden="true"></i>
          </div>
          <div class="dropdown-menu dropdown-menu-right setting-dropdown" aria-labelledby="navbar-language">
            <a class="dropdown-item" @click="setLangLocalstorage('en')">
              <img
                src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png"
                alt=""
                class="mr-2"
                style="width: 20px; height: 20px"
              />
              {{ $t('en') }}
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="setLangLocalstorage('mm')">
              <img
                src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png"
                alt=""
                class="mr-2"
                style="width: 20px; height: 20px"
              />
              {{ $t('mm') }}
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="setLangLocalstorage('cn')">
              <img
                src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png"
                alt=""
                class="mr-2"
                style="width: 20px; height: 20px"
              />
              {{ $t('cn') }}
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="setLangLocalstorage('th')">
              <img
                src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png"
                alt=""
                class="mr-2"
                style="width: 20px; height: 20px"
              />
              {{ $t('th') }}
            </a>
          </div>
        </li>
      </ul>

      <div class="menu-panel__divider"></div>

      <button type="button" class="logout-btn" @click="logout()">
        <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
        {{ $t('setting.logout') }}
      </button>
    </section>

    <div class="page-bottom-spacer setting-page__bottom-spacer" aria-hidden="true"></div>

    <!-- Password modal -->
    <div
      class="modal fade"
      id="editUserPassword"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content setting-modal">
          <div class="setting-modal__accent"></div>
          <div class="modal-body setting-modal__body">
            <h2 class="setting-modal__title">{{ $t('setting.update_password') }}</h2>

            <div class="setting-field">
              <label class="setting-field__label">{{ $t('setting.old_password') }}</label>
              <input v-model="password.old" class="setting-field__input" type="password" />
              <small v-if="errors.old" class="setting-field__error">{{ errors.old }}</small>
            </div>

            <div class="setting-field">
              <label class="setting-field__label">{{ $t('setting.new_password') }}</label>
              <input v-model="password.new" class="setting-field__input" type="password" />
              <small v-if="errors.new" class="setting-field__error">{{ errors.new }}</small>
            </div>

            <div class="setting-field">
              <label class="setting-field__label">{{ $t('setting.confirm_password') }}</label>
              <input v-model="password.confirm" class="setting-field__input" type="password" />
              <small v-if="errors.confirm || errors.confirmPassword" class="setting-field__error">
                {{ errors.confirm || errors.confirmPassword }}
              </small>
            </div>

            <button
              type="button"
              class="setting-modal__submit"
              :disabled="isConfirm"
              @click="changeNewPassword"
            >
              <span v-if="!isConfirm">{{ $t('setting.update') }}</span>
              <Loading v-else color="#1a1a1a" size="24" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      password: {
        user_id: this.$store.state.authUser.id,
      },
      isConfirm: false,
      errors: {},
    };
  },
  methods: {
    ...mapActions(['logoutUser', 'fetchUser']),
    formatAmount(value) {
      const num = Number(value);
      if (Number.isNaN(num)) return '0';
      return num.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 20,
      });
    },
    blurLastFiveCharacters(inputString = '0000000000') {
      const length = inputString.length;
      if (length >= 7) {
        const firstPart = inputString.substring(length - 5, length);
        const blurredCharacters = '*'.repeat(length - 5);
        return blurredCharacters + firstPart;
      }
      return inputString;
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language;
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old =
          this.$store.state.language === 'en'
            ? 'Old password required'
            : 'လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။';
        return false;
      }
      if (!this.password.new) {
        this.errors.new =
          this.$store.state.language === 'en'
            ? 'New password required'
            : 'လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။';
        return false;
      }
      if (!this.password.confirm) {
        this.errors.confirm =
          this.$store.state.language === 'en'
            ? 'Confirm password required'
            : 'အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။';
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword =
          this.$store.state.language === 'en'
            ? 'New passwords not match'
            : 'လျှို့ဝှက်နံပါတ် မတူညီပါ။';
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure?'
            : 'သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မလုပ်တော့ပါ။',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ။',
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => {});
      this.isConfirm = false;
      return true;
    },
    async updateUser() {
      try {
        await axios.post('/auth/userPasswordChange', this.password, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        Toast.success(
          this.$store.state.language === 'en' ? 'Success' : 'အောင်မြင်သည်။'
        );
        this.password = {};
        this.errors = {};
        $('#editUserPassword').modal('hide');
      } catch (error) {
        Toast.fail(
          this.$store.state.language === 'en' ? 'Fail' : 'ကျရှုံးသည်။'
        );
      }
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path !== '/home') {
            this.$router.push('/home');
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => {});
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
  },
};
</script>

<style scoped>
.setting-page {
  padding: 1rem 0.75rem 0;
  background: var(--bg-dark);
}

.setting-page__bottom-spacer {
  height: calc(10rem + env(safe-area-inset-bottom, 0px));
  min-height: calc(10rem + env(safe-area-inset-bottom, 0px));
}

.setting-page__header {
  margin-bottom: 1.25rem;
  padding: 0 0.25rem;
}

.setting-page__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 800;
  color: var(--text-gold);
}

.setting-page__subtitle {
  margin: 0.35rem 0 0;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.setting-panel {
  position: relative;
  margin-bottom: 1rem;
  background: linear-gradient(165deg, #1c1c1c 0%, #121212 55%, #0d0d0d 100%);
  border: 1px solid rgba(207, 167, 87, 0.3);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
}

.setting-panel__accent {
  height: 3px;
  background: var(--gradient-primary);
}

/* Profile card */
.profile-card__body {
  padding: 1.35rem 1.15rem 1.15rem;
}

.profile-card__hero {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.1rem;
}

.profile-card__avatar {
  flex-shrink: 0;
  width: 4.75rem;
  height: 4.75rem;
  border-radius: 50%;
  border: 2px solid rgba(207, 167, 87, 0.55);
  object-fit: cover;
  box-shadow: 0 4px 18px rgba(207, 167, 87, 0.22);
}

.profile-card__identity {
  flex: 1;
  min-width: 0;
}

.profile-card__name {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1.3;
  word-break: break-word;
}

.profile-card__username {
  margin: 0.25rem 0 0;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-gold);
}

.profile-card__balance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  margin-bottom: 0.85rem;
  border-radius: 12px;
  background: rgba(207, 167, 87, 0.1);
  border: 1px solid rgba(207, 167, 87, 0.28);
}

.profile-card__balance-label {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
}

.profile-card__balance-value {
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--text-gold);
  text-align: right;
  line-height: 1.2;
}

.profile-card__balance-value small {
  margin-left: 0.2rem;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--text-secondary);
}

.profile-card__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem;
}

.profile-card__cell {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  padding: 0.75rem 0.85rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.profile-card__cell-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.profile-card__cell-value {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-primary);
  word-break: break-word;
  line-height: 1.35;
}

/* Quick actions */
.quick-actions {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.65rem;
  margin-bottom: 1rem;
}

.quick-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.45rem;
  padding: 0.85rem 0.5rem;
  border: 1px solid rgba(207, 167, 87, 0.25);
  border-radius: 14px;
  background: var(--bg-elevated);
  cursor: pointer;
  transition: border-color 0.2s, transform 0.15s, box-shadow 0.2s;
}

.quick-action:hover {
  border-color: var(--color-primary);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(207, 167, 87, 0.15);
}

.quick-action__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 12px;
  background: rgba(207, 167, 87, 0.12);
  color: var(--text-gold);
  font-size: 1.1rem;
}

.quick-action__label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-align: center;
  line-height: 1.2;
}

/* Menu */
.menu-panel {
  padding-bottom: 1rem;
  margin-bottom: 1.25rem;
}

.menu-list {
  list-style: none;
  margin: 0;
  padding: 0.5rem 0;
}

.menu-list__item {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.85rem 1.15rem;
  cursor: pointer;
  transition: background 0.15s;
}

.menu-list__item:not(.menu-list__item--static):hover {
  background: rgba(207, 167, 87, 0.08);
}

.menu-list__item--static {
  cursor: default;
  opacity: 0.85;
}

.menu-list__item--dropdown {
  position: relative;
}

.menu-list__dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.menu-list__icon {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(207, 167, 87, 0.1);
  color: var(--text-gold);
  font-size: 0.9rem;
}

.menu-list__text {
  flex: 1;
  font-size: 0.92rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.menu-list__arrow {
  flex-shrink: 0;
  font-size: 0.7rem;
  color: var(--text-muted);
}

.menu-panel__divider {
  height: 1px;
  margin: 0 1.15rem;
  background: rgba(255, 255, 255, 0.06);
}

.logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: calc(100% - 2.3rem);
  margin: 0.75rem 1.15rem 0;
  padding: 0.75rem;
  border: 1px solid rgba(255, 100, 100, 0.3);
  border-radius: 12px;
  background: rgba(255, 80, 80, 0.08);
  color: #ffb4b4;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
}

.logout-btn:hover {
  background: rgba(255, 80, 80, 0.15);
}

/* Modal */
.setting-modal {
  background: linear-gradient(165deg, #1c1c1c 0%, #121212 100%) !important;
  border: 1px solid rgba(207, 167, 87, 0.35) !important;
  border-radius: 18px !important;
  overflow: hidden;
}

.setting-modal__accent {
  height: 3px;
  background: var(--gradient-primary);
}

.setting-modal__body {
  padding: 1.5rem 1.75rem 1.75rem !important;
}

.setting-modal__title {
  margin: 0 0 1.25rem;
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--text-gold);
  text-align: center;
}

.setting-field {
  margin-bottom: 1rem;
}

.setting-field__label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
}

.setting-field__input {
  width: 100%;
  height: 2.85rem;
  padding: 0 0.85rem;
  border: 1px solid #333;
  border-radius: 12px;
  background: #1a1a1a;
  color: var(--text-primary);
  font-size: 0.95rem;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.setting-field__input:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(207, 167, 87, 0.15);
}

.setting-field__error {
  display: block;
  margin-top: 0.3rem;
  color: #f0a8a8;
  font-size: 0.78rem;
}

.setting-modal__submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 3rem;
  margin-top: 0.5rem;
  border: none;
  border-radius: 12px;
  background: var(--gradient-primary);
  color: #1a1a1a;
  font-size: 1rem;
  font-weight: 800;
  cursor: pointer;
}

.setting-modal__submit:disabled {
  opacity: 0.9;
  cursor: wait;
}
</style>

<style>
.setting-dropdown {
  background: #1a1a1a !important;
  border: 1px solid rgba(207, 167, 87, 0.3) !important;
  border-radius: 12px !important;
}

.setting-dropdown .dropdown-item {
  color: var(--text-secondary) !important;
}

.setting-dropdown .dropdown-item:hover {
  background: rgba(207, 167, 87, 0.12) !important;
  color: var(--text-gold) !important;
}

.setting-dropdown .dropdown-divider {
  border-color: rgba(255, 255, 255, 0.08) !important;
}
</style>
